import React, { useState } from 'react';
import View from "components/admin/commands/Commands.view";

function Commands() {
    return (
        <View
        />
    );
}

export default Commands;